import { ComponentProps, JSXElementConstructor } from 'react';

import { registerModals } from '@bonanza-social/navigation';
import TermsAndConditionsPage from '../pages/MiscPages/TermsPage/TermsPage';
import PrivacyPolicyPage from '../pages/MiscPages/PrivacyPolicy/PrivacyPolicy';

import '@bonanza-social/auth/modals';
import '@bonanza-social/account/modals';
import '@bonanza-social/details-attestation/modals';
import '@bonanza-social/meta-games/modals';
import '@bonanza-social/registration/modals';
import '@bonanza-social/notifications';

const modals = {
  TermsScreenModal: TermsAndConditionsPage,
  PrivacyModal: PrivacyPolicyPage,
};

registerModals('web', modals);

declare global {
  interface RegisteredModals {
    web: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
